import React from 'react';
import {NavLink, useHistory} from 'react-router-dom';
import {BLOG_ROUTE, ABOUT_US_ROUTE, PLACES_ROUTE, PHOTO_GALLERY_ROUTE} from '../../../../utils/consts';

import styles from './ExploreMenu.module.css';
import ym from "react-yandex-metrika"; // <-- ИЗМЕНЕНО: ИМПОРТ CSS-МОДУЛЕЙ

const ExploreMenu = ({ show, onClose }) => {
    const history = useHistory();

    // Если меню не должно отображаться, не рендерим ничего.
    // Это предотвращает любые нежелательные взаимодействия скрытого бэкдропа.
    if (!show) {
        return null;
    }

    // Когда show == true, мы рендерим обертку, которая будет нашим полноэкранным слоем
    // Внутри этой обертки будет бэкдроп для клика вне, и само содержимое меню
    return (
        <div className={styles.exploreMenuOverlay}> {/* <-- ИЗМЕНЕНО */}
            {/* Бэкдроп: принимает клики для закрытия меню. Покрывает весь оверлей. */}
            <div className={styles.exploreMenuBackdrop} onClick={onClose}></div> {/* <-- ИЗМЕНЕНО */}

            {/* Содержимое меню: позиционируется относительно вьюпорта */}
            <div className={styles.exploreMenuContent}> {/* <-- ИЗМЕНЕНО */}
                <NavLink
                    to={PLACES_ROUTE}
                    className={styles.exploreMenuItem}
                    onClick={() => {
                        ym('reachGoal', `history.push(PLACES_ROUTE) NAVIGATION`);
                        onClose();
                    }}
                >
                    Интересные места
                </NavLink>
                <NavLink
                    to={PHOTO_GALLERY_ROUTE}
                    className={styles.exploreMenuItem}
                    onClick={() => {
                        ym('reachGoal', `history.push(PHOTO_GALLERY_ROUTE) NAVIGATION`);
                        onClose();
                    }}
                >
                    Фотогалерея
                </NavLink>
                <NavLink
                    to={BLOG_ROUTE}
                    className={styles.exploreMenuItem}
                    onClick={() => {
                        ym('reachGoal', `history.push(BLOG_ROUTE) NAVIGATION`);
                        onClose();
                    }}
                >
                    Блог
                </NavLink>
                <NavLink
                    to={ABOUT_US_ROUTE}
                    className={styles.exploreMenuItem}
                    onClick={() => {
                        ym('reachGoal', `history.push(ABOUT_US_ROUTE) NAVIGATION`);
                        onClose();
                    }}
                >
                    О нас
                </NavLink>
            </div>
        </div>
    );
};

export default ExploreMenu;